const ar = {
  nav: {
    home: 'الرئيسية',
    projects: 'المشاريع',
    services: 'الخدمات',
    about: 'من نحن',
    contact: 'اتصل بنا',
    login: 'تسجيل دخول الموظفين',
  },
  hero: {
    title: 'بناء',
    titleSecond: 'الأحلام في',
    titleThird: 'تطوان',
    subtitle: 'بروموتيت هي شركة رائدة في التطوير العقاري في تطوان، المغرب، متخصصة في العقارات السكنية والتجارية والاستثمارية. نحول الرؤى إلى واقع بجودة استثنائية وتصميم مبتكر.',
    cta: 'استكشف المشاريع',
    stats: {
      projects: 'مشروع مكتمل',
      years: 'سنة من التميز',
      clients: 'عميل راضٍ',
    },
  },
  projects: {
    label: 'مشاريعنا',
    title: 'اكتشف',
    titleSecond: 'تطويراتنا المميزة',
    description: 'استكشف محفظة مشاريعنا العقارية الاستثنائية، كل منها مصمم لتوفير الفخامة والراحة وأسلوب حياة متفوق في مواقع رئيسية.',
    compareProjects: 'مقارنة المشاريع',
    showFilters: 'إظهار الفلاتر',
    hideFilters: 'إخفاء الفلاتر',
    filterLocation: 'الموقع',
    filterBedrooms: 'غرف النوم',
    filterPrice: 'نطاق السعر',
    allLocations: 'جميع المواقع',
    allBedrooms: 'جميع غرف النوم',
    bedroom: 'غرفة نوم',
    bedrooms: 'غرف نوم',
    resetFilters: 'إعادة تعيين الفلاتر',
    projectsFound: 'مشاريع موجودة',
    noResults: 'لا توجد مشاريع تطابق الفلاتر الخاصة بك',
  },
  projectDetail: {
    backToProjects: 'العودة إلى المشاريع',
    overview: {
      label: 'نظرة عامة على المشروع',
      title: 'إعادة تعريف الحياة الفاخرة',
      description1: 'يمثل هذا التطوير الاستثنائي قمة الحياة الفاخرة الحديثة في تطوان. من خلال الجمع بين العمارة المعاصرة والتشطيبات الفاخرة، تم تصميم كل التفاصيل بعناية لتوفير تجربة معيشية لا مثيل لها للسكان.',
      description2: 'يقع في واحدة من أكثر المناطق المرغوبة، يوفر هذا المشروع سهولة الوصول إلى جميع وسائل الراحة مع توفير ملاذ هادئ من صخب المدينة. مع مرافق عالمية المستوى ومناظر خلابة، هذا أكثر من مجرد منزل - إنه أسلوب حياة.',
      scheduleVisit: 'جدولة زيارة',
      keyFeatures: 'الميزات الرئيسية',
    },
    features: {
      units: 'الوحدات',
      size: 'نطاق المساحة',
      bedrooms: 'غرف النوم',
      parking: 'موقف السيارات',
      security: 'الأمن',
      delivery: 'التسليم',
      included: 'مشمول',
    },
    gallery: {
      label: 'جولة بصرية',
      title: 'استكشف المساحات',
    },
    amenities: {
      label: 'وسائل الراحة الفاخرة',
      title: 'مرافق عالمية المستوى',
      description: 'استمتع بأسلوب حياة استثنائي مع مجموعتنا الشاملة من وسائل الراحة الفاخرة المصممة لراحتك وملاءمتك.',
      pool: 'حمام سباحة',
      gym: 'مركز لياقة بدنية',
      garden: 'حدائق منسقة',
      concierge: 'خدمة الكونسيرج 24/7',
      retail: 'مساحات تجارية',
      playground: 'ملعب للأطفال',
    },
    location: {
      label: 'موقع متميز',
      title: 'موقع مثالي',
      description: 'يقع في موقع استراتيجي في قلب تطوان، مما يوفر سهولة الوصول إلى المدارس ومراكز التسوق والمطاعم وطرق النقل الرئيسية.',
    },
    cta: {
      title: 'هل أنت مستعد لجعل هذا منزلك؟',
      description: 'اتصل بفريق المبيعات لدينا اليوم لجدولة عرض خاص ومعرفة المزيد عن الوحدات المتاحة وخطط الدفع.',
      contact: 'اتصل بنا',
      download: 'تحميل الكتيب',
    },
  },
  services: {
    label: 'ما نقدمه',
    title: 'حلول عقارية',
    titleSecond: 'شاملة',
    description: 'من التطويرات السكنية إلى المساحات التجارية وفرص الاستثمار، نقدم حلولاً عقارية شاملة مصممة خصيصاً لتلبية احتياجاتك.',
    residential: {
      title: 'التطوير السكني',
      description: 'إنشاء مساحات معيشية حديثة تجمع بين الراحة والأناقة والوظائف للعائلات والأفراد.',
      feature1: 'شقق وفيلات فاخرة',
      feature2: 'وسائل راحة ومرافق حديثة',
      feature3: 'مواقع متميزة في تطوان',
      feature4: 'مبادئ التصميم المستدام',
    },
    commercial: {
      title: 'العقارات التجارية',
      description: 'تطوير مساحات تجارية استراتيجية مصممة لتعزيز نمو الأعمال وتجربة العملاء.',
      feature1: 'مساحات البيع بالتجزئة والمكاتب',
      feature2: 'مواقع ذات حركة مرور عالية',
      feature3: 'تخطيطات مرنة',
      feature4: 'بنية تحتية حديثة',
    },
    investment: {
      title: 'فرص الاستثمار',
      description: 'تقديم خيارات استثمار عقاري مربحة مع عوائد قوية وتقدير قيمة طويل الأجل.',
      feature1: 'إمكانات عائد استثمار عالية',
      feature2: 'خيارات محفظة متنوعة',
      feature3: 'تحليل سوق خبير',
      feature4: 'عمليات شفافة',
    },
    process: {
      title: 'عملية التطوير لدينا',
      step1: {
        title: 'الاستشارة',
        description: 'فهم احتياجاتك ورؤيتك',
      },
      step2: {
        title: 'التخطيط',
        description: 'تصميم مفصل واستراتيجية تطوير',
      },
      step3: {
        title: 'البناء',
        description: 'تنفيذ عالي الجودة مع فرق خبراء',
      },
      step4: {
        title: 'التسليم',
        description: 'التسليم والدعم المستمر',
      },
    },
  },
  about: {
    label: 'حول بروموتيت',
    title: 'التميز في التطوير العقاري',
    description: 'مع أكثر من 15 عاماً من الخبرة، أثبتت بروموتيت نفسها كاسم موثوق في سوق العقارات في تطوان. نحن ملتزمون بإنشاء عقارات استثنائية تعزز المجتمعات وتقدم قيمة دائمة.',
    number: '15',
    numberText: 'سنة من تحويل مشهد تطوان بتطويرات عقارية مبتكرة تضع معايير جديدة للجودة والتصميم.',
    cta: 'اعرف المزيد',
    story: {
      title: 'قصتنا',
      paragraph1: 'تأسست بروموتيت في عام 2008 برؤية بسيطة: تحويل المشهد العقاري في تطوان من خلال التصميم المبتكر والجودة الاستثنائية. على مر السنين، نمونا من شركة تطوير صغيرة إلى واحدة من أكثر شركات العقارات احتراماً في المنطقة.',
      paragraph2: 'يُبنى نجاحنا على أساس من النزاهة والخبرة والفهم العميق لاحتياجات عملائنا. كل مشروع نقوم به يعكس التزامنا بالتميز وشغفنا بإنشاء مساحات تعزز الحياة.',
    },
    mission: {
      title: 'مهمتنا',
      paragraph1: 'نحن ملتزمون بتطوير عقارات لا تلبي فقط أعلى معايير الجودة والتصميم، بل تساهم أيضاً بشكل إيجابي في المجتمعات التي نخدمها. مهمتنا هي إنشاء مساحات مستدامة ومبتكرة تصمد أمام اختبار الزمن.',
      paragraph2: 'من خلال التخطيط الدقيق والتنفيذ الخبير والالتزام المستمر تجاه عملائنا، نسعى جاهدين لتجاوز التوقعات وتقديم قيمة استثنائية في كل مشروع نقوم به.',
    },
    values: {
      title: 'قيمنا الأساسية',
      value1: {
        title: 'النزاهة',
        description: 'نمارس الأعمال بصدق وشفافية وممارسات أخلاقية في كل تفاعل.',
      },
      value2: {
        title: 'الابتكار',
        description: 'نتبنى أفكاراً وتقنيات جديدة لإنشاء حلول عقارية متطورة.',
      },
      value3: {
        title: 'التميز',
        description: 'نحن ملتزمون بتقديم أعلى جودة في كل جانب من جوانب عملنا.',
      },
    },
  },
  testimonials: {
    label: 'شهادات العملاء',
    title: 'ما يقوله',
    titleSecond: 'عملاؤنا',
  },
  contact: {
    title: 'تواصل معنا',
    subtitle: 'هل أنت مستعد لبدء رحلتك العقارية؟ اتصل بنا اليوم لمناقشة مشروعك أو فرصة الاستثمار.',
    form: {
      title: 'أرسل لنا رسالة',
    },
    name: 'اسمك',
    email: 'عنوان البريد الإلكتروني',
    phone: 'رقم الهاتف',
    message: 'رسالتك',
    submit: 'إرسال الرسالة',
    sending: 'جاري الإرسال...',
    success: 'شكراً لك! سنتواصل معك قريباً.',
    error: 'حدث خطأ ما. يرجى المحاولة مرة أخرى.',
    info: {
      title: 'معلومات الاتصال',
      address: 'العنوان',
      addressText: 'شارع محمد الخامس، تطوان 93000، المغرب',
      phone: 'الهاتف',
      phoneText: '+212 539 123 456',
      email: 'البريد الإلكتروني',
      emailText: 'contact@promotet.ma',
    },
  },
  footer: {
    description: 'شريكك الموثوق في تطوير العقارات الفاخرة في جميع أنحاء بلجيكا.',
    quickLinks: 'روابط سريعة',
    services: 'الخدمات',
    contact: 'اتصل بنا',
    rights: 'جميع الحقوق محفوظة.',
    privacy: 'سياسة الخصوصية',
    terms: 'الشروط والأحكام',
  },
  compare: {
    label: 'أداة المقارنة',
    title: 'مقارنة المشاريع',
    description: 'اختر ما يصل إلى 3 مشاريع لمقارنة ميزاتها وأسعارها ووسائل الراحة جنبًا إلى جنب. اتخذ قرارًا مستنيرًا لاستثمارك.',
    selectProjects: 'اختر المشاريع للمقارنة',
    selectDescription: 'اختر ما يصل إلى 3 مشاريع من محفظتنا',
    comparison: 'المقارنة',
    viewDetails: 'عرض التفاصيل',
    selectProject: 'اختر المشروع',
    noProjects: 'لم يتم اختيار مشاريع',
    noProjectsDescription: 'يرجى اختيار مشروع واحد على الأقل من الأعلى لبدء المقارنة.',
    browseProjects: 'تصفح جميع المشاريع',
    features: {
      price: 'نطاق السعر',
      location: 'الموقع',
      units: 'إجمالي الوحدات',
      size: 'حجم الوحدة',
      bedrooms: 'غرف النوم',
      parking: 'موقف السيارات',
      security: 'الأمن',
      delivery: 'التسليم',
      included: 'مشمول',
    },
  },
  privacy: {
    title: 'سياسة الخصوصية',
    lastUpdated: 'آخر تحديث: يناير 2025',
    intro: {
      title: 'مقدمة',
      content: 'في لوكس إستيت، نحن ملتزمون بحماية خصوصيتك وضمان أمان معلوماتك الشخصية. توضح سياسة الخصوصية هذه كيفية جمع واستخدام والكشف عن وحماية معلوماتك عند زيارة موقعنا الإلكتروني أو استخدام خدماتنا.',
    },
    collect: {
      title: 'المعلومات التي نجمعها',
      content: 'نجمع المعلومات التي تقدمها لنا مباشرة، بما في ذلك:',
      item1: 'معلومات التعريف الشخصية (الاسم، عنوان البريد الإلكتروني، رقم الهاتف)',
      item2: 'تفضيلات العقارات ومعايير البحث',
      item3: 'سجلات الاتصال والمراسلات',
      item4: 'البيانات التقنية مثل عنوان IP ونوع المتصفح ومعلومات الجهاز',
    },
    use: {
      title: 'كيف نستخدم معلوماتك',
      content: 'نستخدم المعلومات التي نجمعها من أجل:',
      item1: 'تقديم وتحسين خدماتنا العقارية',
      item2: 'التواصل معك بشأن العقارات والخدمات',
      item3: 'إرسال اتصالات تسويقية لك (بموافقتك)',
      item4: 'تحليل استخدام الموقع وتحسين تجربة المستخدم',
      item5: 'الامتثال للالتزامات القانونية وحماية حقوقنا',
    },
    protection: {
      title: 'حماية البيانات',
      content: 'نطبق التدابير التقنية والتنظيمية المناسبة لحماية معلوماتك الشخصية من الوصول غير المصرح به أو التعديل أو الكشف أو التدمير. ومع ذلك، لا توجد طريقة نقل عبر الإنترنت آمنة بنسبة 100٪، ولا يمكننا ضمان الأمان المطلق.',
    },
    cookies: {
      title: 'ملفات تعريف الارتباط والتتبع',
      content: 'نستخدم ملفات تعريف الارتباط وتقنيات التتبع المماثلة لتحسين تجربة التصفح الخاصة بك، وتحليل حركة المرور على الموقع، وتخصيص المحتوى. يمكنك التحكم في إعدادات ملفات تعريف الارتباط من خلال تفضيلات المتصفح الخاص بك.',
    },
    thirdParty: {
      title: 'خدمات الطرف الثالث',
      content: 'قد نشارك معلوماتك مع مزودي خدمات طرف ثالث موثوق بهم يساعدوننا في تشغيل موقعنا الإلكتروني وإدارة أعمالنا. هذه الأطراف ملزمة بالحفاظ على سرية معلوماتك واستخدامها فقط للأغراض التي نحددها.',
    },
    rights: {
      title: 'حقوقك',
      content: 'بموجب اللائحة العامة لحماية البيانات وقوانين حماية البيانات المعمول بها، لديك الحق في:',
      item1: 'الوصول إلى بياناتك الشخصية',
      item2: 'تصحيح البيانات غير الدقيقة أو غير الكاملة',
      item3: 'طلب حذف بياناتك',
      item4: 'الاعتراض على أو تقييد معالجة بياناتك',
    },
    contact: {
      title: 'اتصل بنا',
      content: 'إذا كان لديك أي أسئلة حول سياسة الخصوصية هذه أو ممارساتنا المتعلقة بالبيانات، يرجى الاتصال بنا:',
    },
  },
  terms: {
    title: 'الشروط والأحكام',
    lastUpdated: 'آخر تحديث: يناير 2025',
    intro: {
      title: 'مقدمة',
      content: 'مرحبًا بك في لوكس إستيت. تحكم هذه الشروط والأحكام استخدامك لموقعنا الإلكتروني وخدماتنا. من خلال الوصول إلى موقعنا الإلكتروني أو استخدامه، فإنك توافق على الالتزام بهذه الشروط. إذا كنت لا توافق على أي جزء من هذه الشروط، يرجى عدم استخدام خدماتنا.',
    },
    acceptance: {
      title: 'قبول الشروط',
      content: 'من خلال الوصول إلى هذا الموقع واستخدامه، فإنك تقبل وتوافق على الالتزام بشروط وأحكام هذا الاتفاق. بالإضافة إلى ذلك، عند استخدام خدمات معينة، ستخضع لأي إرشادات أو قواعد منشورة تنطبق على هذه الخدمات.',
    },
    services: {
      title: 'استخدام الخدمات',
      content: 'توافق على استخدام خدماتنا فقط للأغراض القانونية ووفقًا لهذه الشروط. توافق على عدم:',
      item1: 'استخدام الخدمات بأي طريقة تنتهك أي قانون أو لائحة معمول بها',
      item2: 'الانخراط في أي سلوك يقيد أو يمنع استخدام أي شخص للخدمات',
      item3: 'محاولة الحصول على وصول غير مصرح به إلى أي جزء من الموقع',
      item4: 'استخدام أي نظام آلي للوصول إلى الخدمات بطريقة ترسل طلبات أكثر مما يمكن للإنسان إنتاجه بشكل معقول',
    },
    property: {
      title: 'معلومات العقارات',
      content: 'جميع معلومات العقارات والصور والأوصاف المقدمة على هذا الموقع هي لأغراض إعلامية فقط. بينما نسعى جاهدين لضمان الدقة، لا نضمن أن جميع المعلومات كاملة أو دقيقة أو محدثة. توافر العقارات والأسعار عرضة للتغيير دون إشعار.',
    },
    intellectual: {
      title: 'الملكية الفكرية',
      content: 'المحتوى الموجود على هذا الموقع، بما في ذلك النصوص والرسومات والشعارات والصور والبرامج، هو ملك لشركة لوكس إستيت أو موفري المحتوى الخاصين بها ومحمي بموجب قوانين حقوق النشر الدولية. لا يجوز لك إعادة إنتاج أو توزيع أو إنشاء أعمال مشتقة دون إذن كتابي صريح منا.',
    },
    liability: {
      title: 'تحديد المسؤولية',
      content: 'لن تكون لوكس إستيت مسؤولة عن أي أضرار غير مباشرة أو عرضية أو خاصة أو تبعية أو عقابية ناتجة عن استخدامك أو عدم قدرتك على استخدام الخدمات. لن تتجاوز مسؤوليتنا الإجمالية المبلغ الذي دفعته، إن وجد، للوصول إلى خدماتنا.',
    },
    indemnification: {
      title: 'التعويض',
      content: 'توافق على تعويض وإعفاء لوكس إستيت والشركات التابعة لها والمسؤولين والوكلاء والموظفين من أي مطالبة أو طلب، بما في ذلك أتعاب المحاماة المعقولة، يقدمها أي طرف ثالث بسبب أو ناشئ عن انتهاكك لهذه الشروط أو انتهاكك لأي قانون أو حقوق طرف ثالث.',
    },
    modifications: {
      title: 'تعديلات الشروط',
      content: 'نحتفظ بالحق في تعديل هذه الشروط في أي وقت. سنخطرك بأي تغييرات عن طريق نشر الشروط الجديدة على هذه الصفحة وتحديث تاريخ "آخر تحديث". استمرارك في استخدام الخدمات بعد هذه التعديلات يشكل قبولك للشروط المحدثة.',
    },
    law: {
      title: 'القانون الحاكم',
      content: 'تخضع هذه الشروط وتفسر وفقًا لقوانين بلجيكا، دون النظر إلى أحكام تنازع القوانين الخاصة بها. أي نزاعات تنشأ عن هذه الشروط ستخضع للاختصاص القضائي الحصري لمحاكم بروكسل، بلجيكا.',
    },
    contact: {
      title: 'معلومات الاتصال',
      content: 'إذا كان لديك أي أسئلة حول هذه الشروط والأحكام، يرجى الاتصال بنا:',
    },
  },
};

export default ar;
